import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AumicoCoreProvider } from '@modeso/aumico-lib-core-fe';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable, finalize, mergeMap, of } from 'rxjs';
import { AcceptInvitationDto } from '../dtos/acceptInvitationDto.interface';
import { GetInvitationDto } from '../dtos/getInvitationDto.interface';
import { ISetOrResetPasswordRequest } from '../interfaces/set-or-reset-password-request.interface';
import { RoutesUtil } from '../util/RoutesUtil';
@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class InvitationService {
    /**
     *
     * @param http the http client instance
     * @param config the configurations for the library
     */
    constructor(
        private readonly http: HttpClient,
        private readonly coreProvider: AumicoCoreProvider,
        private readonly routesUtil: RoutesUtil,
    ) {}

    getInvitationByUrl(uuid: string): Observable<GetInvitationDto> {
        this.coreProvider.dispatchBlockingRequest('UsersFe_invitationByUuid$');
        const url = this.routesUtil.getInvitationByUuid(uuid);
        return this.http
            .get<GetInvitationDto>(url)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('UsersFe_invitationByUuid$')));
    }

    acceptInvitation$(
        uuid: string,
        acceptInvitationDto: AcceptInvitationDto,
        setPassword: ISetOrResetPasswordRequest,
    ): Observable<string> {
        this.coreProvider.dispatchBlockingRequest('UsersFe_acceptInvitation$');
        const url = this.routesUtil.acceptInvitation(uuid);

        return this.http.patch(url, acceptInvitationDto, { responseType: 'text' }).pipe(
            mergeMap((response) => {
                setPassword.oobCode = response;
                return of(response);
            }),
            finalize(() => this.coreProvider.dispatchBlockingRequestEnd('UsersFe_acceptInvitation$')),
        );
    }
}
